export default class Helpers {
  static runOnceCookie(cookieName, cookieAge, func) {
    const cookieExists = document.cookie.split(";").some((item) => item.trim().indexOf(cookieName + "=") == 0);
    if ( cookieExists ) { return; };

    document.cookie = `${cookieName}=1;max-age=${cookieAge}`;
    func();
  }
}
